<script lang="ts">
	import { menu } from '@tools/Menu.svelte';
	// import { cubicOut } from 'svelte/easing';
	// import { tweened } from 'svelte/motion';

	// const ratio = tweened(1, {
	// 	duration: 300,
	// 	easing: cubicOut
	// });

	// $effect(() => {
	// 	ratio.set(open ? 1 : 0);
	// });
</script>

<button
	title={menu.isOpen ? 'Luk menu' : 'Åben menu'}
	onclick={() => (menu.isOpen ? menu.close() : menu.clickMobile())}
	aria-label="Menu"
>
	<svg
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		stroke="currentColor"
		stroke-width="2"
		stroke-linecap="square"
		stroke-linejoin="round"
	>
		<path d={menu.isOpen ? `M3 21L21 3` : `M0 5L24 5`} />
		<path
			d={menu.isOpen ? `M12 12L12 12` : `M0 12L24 12`}
			stroke="currentColor"
			stroke-width="2"
			stroke-linecap="square"
			stroke-linejoin="round"
		/>
		<path
			d={menu.isOpen ? `M3 3L21 21` : `M0 19L24 19`}
			stroke="currentColor"
			stroke-width="2"
			stroke-linecap="square"
			stroke-linejoin="round"
		/>
	</svg>
</button>

<style lang="scss">
	button {
		padding-left: var(--gap);
		padding-right: var(--gutter);
	}

	svg {
		height: $gap5;
		width: $gap5;
	}
</style>
